import { marked } from 'marked';

marked.setOptions({
    breaks: true,
    gfm: true,
    headerIds: false,
    mangle: false,
});

export function renderMarkdown(text) {
    if (!text) return '';
    try {
        return marked.parse(String(text));
    } catch (e) {
        return escapeHtml(String(text));
    }
}

function escapeHtml(s) {
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
